import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import { exposeItems } from "@/mocks/feed";

const categories = ["全部", "明星", "网红", "综艺", "影视", "恋情", "争议", "品牌"];

export default function ExposeFilter() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(() => {
    if (active === "全部") return exposeItems;
    return exposeItems.filter(
      (item) => item.category === active || item.tags.includes(active)
    );
  }, [active]);

  return (
    <section id="expose" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="FILTER · 爆料分类"
        title="按类别挑你想看的瓜"
        desc="点击标签即可筛选本页已有的爆料条目，无需等待加载。再点「全部」可以恢复完整列表。"
      />

      <div className="mt-7 flex flex-wrap gap-2">
        {categories.map((cat) => {
          const isActive = active === cat;
          return (
            <button
              key={cat}
              type="button"
              onClick={() => setActive(cat)}
              aria-pressed={isActive}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap border ${
                isActive
                  ? "bg-primary-500 text-background-50 border-primary-500"
                  : "bg-background-100 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {cat}
            </button>
          );
        })}
      </div>

      <p className="mt-4 text-sm text-foreground-500">
        当前筛选：
        <span className="text-primary-600 font-medium">{active}</span>
        ，共 {filtered.length} 条
      </p>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((item) => (
          <article
            key={item.id}
            className="group flex flex-col bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
          >
            <div className="relative w-full h-44 overflow-hidden">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute top-3 left-3 flex gap-2">
                <span className="bg-background-50/90 backdrop-blur text-primary-700 text-xs font-medium px-2.5 py-1 rounded-md">
                  {item.category}
                </span>
              </div>
              <span className="absolute bottom-3 right-3 bg-foreground-950/70 backdrop-blur text-background-50 text-xs px-2.5 py-1 rounded-md">
                <i className="ri-fire-line mr-1" />
                {item.heat}
              </span>
            </div>
            <div className="flex flex-col flex-1 p-4 md:p-5">
              <h3 className="text-base font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-3 flex-1">
                {item.summary}
              </p>
              <div className="mt-4 pt-3 border-t border-background-200 flex flex-wrap items-center gap-x-3 gap-y-1.5 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-user-voice-line" />
                  {item.source}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" />
                  {item.time}
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}